import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { PurpleStorageService, PurpleTranslationPipe } from 'purple-lib';
import { lastValueFrom } from 'rxjs';
import { PurpleSalesNotificationService } from 'src/app/components/purple-sales-notification.service';
import { AppTranslationService } from 'src/core-modules/localization/localization.service';
import { BookingService, PurpleApiResponseStatus } from 'src/core-modules/sdk/api';
import { environment } from 'src/environments/default/environment';
function switchCompanyRedirect() {
  return environment.COMPANY_ABB == 'ke' || environment.COMPANY_ABB == 'swpr';
}
@Component({
  selector: 'app-redeem-referral',
  templateUrl: './redeem-referral.component.html',
  styleUrls: ['./redeem-referral.component.scss']
})
export class RedeemReferralComponent implements OnInit {

  constructor(private tsvc: AppTranslationService, private bookSvc: BookingService, private route: ActivatedRoute, private tranPipe: PurpleTranslationPipe,
    private mesSvc: NzMessageService, private storageSvc: PurpleStorageService, private router: Router, private psNotSvc: PurpleSalesNotificationService) { }
  //referralId: string | undefined;

  isKering: boolean = switchCompanyRedirect();

  async ngOnInit() {
    this.route.queryParams
      .subscribe(async params => {
        const referralId = params['id'];

        const res = await lastValueFrom(this.bookSvc.checkReferralCode(this.tsvc.currentLanguage.value, {
          referralId: referralId
        }));

        if (res.status == PurpleApiResponseStatus.Success) {
          this.storageSvc.set('Referral', res.data, 'session');
          await this.router.navigate([this.tsvc.currentLanguage.value, 'event', 'detail', res.data?.saleEventCode], {queryParams: {returnUrl: "/"+this.tsvc.currentLanguage.value+"/event/detail/"+res.data?.saleEventCode}});

        } else if (res.status == PurpleApiResponseStatus.Warning) {

          if(res.data != undefined){
            this.storageSvc.set('Referral', res.data, 'session');

            this.mesSvc.warning(res.message, {
              nzDuration: 5000
            });

            await this.router.navigate([this.tsvc.currentLanguage.value, 'event', 'detail', res.data?.saleEventCode], {queryParams: {returnUrl: "/"+this.tsvc.currentLanguage.value+"/event/detail/"+res.data?.saleEventCode}});
          }else{
            this.mesSvc.warning(res.message, {
              nzDuration: 5000
            });
  
            await this.router.navigate([this.tsvc.currentLanguage.value, 'login']);
          }

        } else {
          this.psNotSvc.showMotSimpleNotification(
            this.tranPipe.transform('error_message_default_title', 'Qualcosa è andato storto', []),
            res.message,
            this.tranPipe.transform('error_message_default_button', 'Ok', []),
            undefined, 'modal', true, undefined, undefined, false, false, false, false)
          
          if(this.isKering){
            await this.router.navigate([this.tsvc.currentLanguage.value, 'login']);

          }else{
            await this.router.navigate([this.tsvc.currentLanguage.value, ]);
          }
        }
      });

      await this.router.navigate(['404']);

  }

}
